export const historyHeaders = [
  {
    text: 'Usuario',
    align: 'start',
    sortable: false,
    filterable: false,
    value: 'username',
  },
  {
    text: 'Nombre Archivo',
    align: 'start',
    sortable: false,
    filterable: false,
    value: 'filename',
  },
  {
    text: 'Archivo',
    align: 'start',
    sortable: false,
    filterable: true,
    filter_type: 'select',
    value: 'format',
  },
  {
    text: 'ID Contrato',
    align: 'start',
    sortable: false,
    filterable: false,
    value: 'contract_id',
  },
  {
    text: 'Contrato',
    align: 'start',
    sortable: false,
    filterable: true,
    filter_type: 'select',
    value: 'contract_name',
  },
  {
    text: 'Periodo',
    align: 'start',
    sortable: false,
    filterable: true,
    filter_type: 'select',
    value: 'month',
  },
  {
    text: 'Año',
    align: 'start',
    sortable: false,
    filterable: true,
    filter_type: 'text',
    value: 'year',
  },
  {
    text: 'Fecha de subida',
    align: 'start',
    sortable: false,
    filterable: false,
    value: 'date',
  },
  {
    text: 'Actualización',
    align: 'start',
    sortable: false,
    filterable: false,
    value: 'updateDate',
  },
  { 
    text: 'Acción', 
    value: 'actions', 
    sortable: false,
    filterable: false,
    align: 'start',
  }
]
export const errorHeaders = [
  {
    text: 'ID de usuario',
    align: 'start',
    sortable: false,
    value: 'userId',
  },
  {
    text: 'Código',
    align: 'center',
    sortable: false,
    value: 'errorCode',
  },
  {
    text: 'Fecha',
    align: 'center',
    sortable: false,
    value: 'date',
  },
  {
    text: 'Mensaje',
    align: 'center',
    sortable: false,
    value: 'userMessage',
  },
  {
    text: 'Nombre archivo',
    align: 'center',
    sortable: false,
    value: 'filename',
  },
]
export const months = [
  "ENERO",
  "FEBRERO",
  "MARZO",
  "ABRIL",
  "MAYO",
  "JUNIO",
  "JULIO",
  "AGOSTO",
  "SEPTIEMBRE",
  "OCTUBRE",
  "NOVIEMBRE",
  "DICIEMBRE"
]
export const fileNames = [
  "CEDULA CONTABLE",
  "CEDULA FINANCIERA",
  "CEDULA OPERATIVA",
  "CEDULA PRODUCCION",
  "FINANZAS CEE",
  "FMP49 LICENCIAS",
  "FMP50 LICENCIAS",
  "FMP53",
  "FMP54",
  "PRODUCCION CEE",
  "SIPAC CEE"
]
export const contractNames = [
  "Nejo",
  "San Andrés",
  "Tierra Blanca",
  "Pitepec",
  "Amatitlán",
  "Soledad",
  "Miahuapán",
  "Altamira",
  "Arenque",
  "Santuario y El Golpe",
  "Misión",
  "Ébano",
  "Miquetla",
  "Trion",
  "Ogarrio",
  "Cárdenas - Mora"
]